import { CPF_FILTER, CpfFilterType } from "../../filter/types";

export interface CpfFilterOption {
  value: CpfFilterType;
  label: string;
}

export type BlockedOptionValue = "true" | "false" | "all";

export interface BlockedOption {
  value: BlockedOptionValue;
  label: string;
}

export const CPF_FILTER_OPTIONS: CpfFilterOption[] = [
  { value: CPF_FILTER.VALID, label: "Válido" },
  { value: CPF_FILTER.INVALID, label: "Inválido" },
  { value: CPF_FILTER.ALL, label: "Todos" },
];

export const BLOCKED_OPTIONS: BlockedOption[] = [
  { value: "all", label: "Todos" },
  { value: "true", label: "Bloqueado" },
  { value: "false", label: "Desbloqueado" },
];
